import { Expose } from "class-transformer";
import { EmployeeDocumentOriginEnum } from "@/core/features/employee-documents/employee-document-origin.enum";

export class CreateEmployeeDocumentSignedUploadDto {
  @Expose()
  employeeId: string;

  @Expose()
  categoryId: string;

  @Expose()
  filename: string;

  @Expose()
  mimetype: string;

  @Expose()
  size: number;

  @Expose()
  contentHash: string;

  @Expose()
  origin: EmployeeDocumentOriginEnum;
}
